import ApiBase from '../ApiBase';

class Me extends ApiBase {
    /**
     * @method getMe
     * @param {object} data
     * @return {Promise<*>}
     */
    getMe = (data) => {
        return this.get('me', data);
    };

    /**
     * @method update
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    update = async (data) => {
        return this.patch(
            'me',
            data,
            data.user_id ? 'ignore' : 'update' // We don't want to refresh the User service if updating a different user.
        );
    };

    /**
     * @method updatePassword
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    updatePassword = (data) => {
        return this.patch('me/password', data, 'update-password');
    };

    /**
     * @method updateAvatar
     * @param {object} data
     * @return {Promise<boolean|{status: number}|*>}
     */
    updateAvatar = async (data) => {
        return this.patch('me/avatar', data, 'update-avatar');
    };

    /**
     * @method updateTeam
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    updateTeam = (data) => {
        return this.patch('me/team', data, 'update-team');
    };

    /**
     * @method remove
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    remove = (data) => {
        return this.delete('me', 'delete', 204, {
            data
        });
    };

    registration = (data) => this.post(`me/registration`, data, 'update');

    registrationLookup = (data) => this.post('me/registration/lookup', data);

}

export default new Me();
